import React, { useContext, useEffect, useState } from 'react'
import API from '../../../../services/API'
import {
  Button,
  Checkbox,
  Chip,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from '@mui/material'
import QuickActionCard from '../../../../components/Cards/QuickActionCard'
import WorkspacesIcon from '@mui/icons-material/Workspaces'
import SaveIcon from '@mui/icons-material/Save'
import SmallModal from '../../../../components/Modals/SmallModal'
import DetailsBox, { DetailRow } from '../../../../components/Cards/DetailsBox'
import DataSaverOnIcon from '@mui/icons-material/DataSaverOn'
import { GlobalContext } from '../../../../App'
import BigModal from '../../../../components/Modals/BigModal'
import EditIcon from '@mui/icons-material/Edit'
import EditCategory from './EditCategory'
import AddField from './AddField'
import CategoryTable from './CategoryTable'

const VDI = () => {
  const [data, setData] = useState({})
  const [vehicleTypeOptions, setVehicleTypeOptions] = useState([])
  const [changesPresent, setChangesPresent] = useState(false)
  const [addCategory, setAddCategory] = useState({})
  const { setToast } = useContext(GlobalContext)
  const [selectedCategory, setSelectedCategory] = useState('')

  const [editCategory, setEditCategory] = useState('')

  useEffect(() => {
    API.get('/vdioptions')
      .then((res) => {
        if (res.status === 200) {
          res.data.vdiOptions &&
            Object.keys(res.data.vdiOptions).length > 0 &&
            setData(res.data.vdiOptions)
          setVehicleTypeOptions(res.data.vehicleTypes)
        }
      })
      .catch((e) => console.log(e))
  }, [])

  const handleSaveChanges = () => {
    API.post('/vdioptions', data).then((res) => {
      if (res.status === 200) {
        setChangesPresent(false)
        setToast({ message: 'Changes Saved' })
      } else {
        setToast({
          message: 'Unable to save Changes. Please try again later.',
          severity: 'error',
        })
      }
    })
  }

  return (
    <Stack gap={1}>
      <Stack>
        <Typography variant="title2">VDI Settings</Typography>
        <Typography variant="caption">
          Use this page to edit the VDI forms
        </Typography>
      </Stack>
      <Stack direction="row" justifyContent="space-between">
        <Stack direction="row">
          <Button
            onClick={() => setAddCategory((prev) => ({ ...prev, open: true }))}
            startIcon={<WorkspacesIcon />}
            color="anBlue"
            variant="contained"
          >
            Add a Category
          </Button>
        </Stack>
        <Button
          onClick={handleSaveChanges}
          variant="contained"
          color="success"
          startIcon={<SaveIcon />}
          disabled={!changesPresent}
        >
          Save Changes
        </Button>
      </Stack>
      <Stack gap={1}>
        {Object.keys(data).map((category) => (
          <CategoryTable
            key={category}
            category={category}
            setEditCategory={setEditCategory}
            setSelectedCategory={setSelectedCategory}
            data={data}
            setData={setData}
            setChangesPresent={setChangesPresent}
            vehicleTypeOptions={vehicleTypeOptions}
          />
        ))}
      </Stack>
      <SmallModal
        open={!!addCategory.open}
        onClose={() => setAddCategory((prev) => ({ ...prev, open: false }))}
      >
        <Stack
          component="form"
          onSubmit={(e) => {
            e.preventDefault()
            if (Object.keys(data).includes(addCategory.value)) {
              setAddCategory((prev) => ({ ...prev, dupError: true }))
            } else {
              setData((prev) => ({ ...prev, [addCategory.value]: [] }))
              setChangesPresent(true)
              setAddCategory({})
            }
          }}
          gap={1}
          padding={0.5}
        >
          <TextField
            value={addCategory.value ?? ''}
            autoComplete="off"
            required
            error={addCategory.dupError}
            helperText={addCategory.dupError && 'This Category already exists'}
            onChange={(e) =>
              setAddCategory((prev) => ({ ...prev, value: e.target.value }))
            }
            label="Category Name"
          />
          <Button
            type="submit"
            variant="contained"
            size="small"
            color="success"
          >
            Submit
          </Button>
        </Stack>
      </SmallModal>
      <EditCategory
        data={data}
        setData={setData}
        category={editCategory}
        onClose={() => setEditCategory('')}
        setChangesPresent={setChangesPresent}
      />
      <AddField
        selectedCategory={selectedCategory}
        setSelectedCategory={setSelectedCategory}
        data={data}
        setData={setData}
        setChangesPresent={setChangesPresent}
        vehicleTypeOptions={vehicleTypeOptions}
      />
    </Stack>
  )
}

export default VDI
